<template>
  <div class="wrapper">
    <b-breadcrumb :items="breadcrumb"/>

    <div class="row">
      <div class="col-sm-9">
        <h1>{{page.name}}</h1>

        <b-list-group>
          <b-list-group-item v-for="descendant in page.children" :key="descendant.id">
            <router-link :to="{ name: 'Page', params: { page_id: descendant.id }}">{{descendant.name}}</router-link>  <i class="icon-arrow-right"></i>
          </b-list-group-item>
        </b-list-group>

        <div class="content" v-html="page.text"></div>
      </div>
      <div class="col-sm-3" v-if="page.type=='item'">
        <h5>Related</h5>
        <b-list-group>
          <b-list-group-item v-for="page in related_pages" :key="page.id">
            <router-link :to="{ name: 'Page', params: { page_id: page.id }}">{{page.name}}</router-link> <i class="icon-arrow-right"></i>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>



  </div>
</template>

<script>
  import Router from '../router';

export default {
  name: 'Page',
  data () {
    return {
      page: {},
      related_pages: [],
      breadcrumb: [],
      page_id: this.$route.params.page_id
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.page_id = to.params.page_id
    next()
    this.getPage()
  },
  mounted: function() {
    this.getPage()
  },
  methods: {
    getPage() {

      axios.get(this.$conf.apiHost+'/api/faq/categories/'+this.page_id+"?site_id="+this.$conf.siteId).then((response) => {
        this.page = response.data.data;
        this.page.text = this.page.text.replaceAll('/uploads/support/categories/', this.$conf.apiHost + '/uploads/support/categories/');
        this.related_pages = response.data.related;
        this.getBreadcrumb()
      });
    },
    getBreadcrumb() {
        let _this = this
        _this.breadcrumb = []

        _this.page.ancestors.map(function(value, key) {
          _this.breadcrumb.push({
            text: value.name,
            to: { name: 'Page', params: { page_id: value.id }}
          });
        });
        _this.breadcrumb.push({
          text: this.page.name,
          active:true
        });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page.vue